'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus from "./dev.cheleb.scalamigen.-Validation-Status.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid(message, visible) {
  this.hB = null;
  this.g5 = false;
  this.hB = message;
  this.g5 = visible;
}
export { $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid as $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid };
$p = $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid.prototype = new $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus.$h_Ldev_cheleb_scalamigen_ValidationStatus();
$p.constructor = $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_ValidationStatus$Invalid() {
}
export { $h_Ldev_cheleb_scalamigen_ValidationStatus$Invalid as $h_Ldev_cheleb_scalamigen_ValidationStatus$Invalid };
$h_Ldev_cheleb_scalamigen_ValidationStatus$Invalid.prototype = $p;
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-670529065));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.hB));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.g5 ? 1231 : 1237));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid) && ((this.g5 === x$0.g5) && (this.hB === x$0.hB))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Invalid";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.hB;
  }
  if ((n === 1)) {
    return this.g5;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Ldev_cheleb_scalamigen_ValidationStatus$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d7)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_ValidationStatus$Invalid as $isArrayOf_Ldev_cheleb_scalamigen_ValidationStatus$Invalid };
var $d_Ldev_cheleb_scalamigen_ValidationStatus$Invalid = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid, "dev.cheleb.scalamigen.ValidationStatus$Invalid", ({
  d7: 1,
  ji: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Ldev_cheleb_scalamigen_ValidationStatus$Invalid as $d_Ldev_cheleb_scalamigen_ValidationStatus$Invalid };
